module.exports = __webpack_public_path__ + "img/zw.1ef24c29.jpg";